var map = {
	"./ahv.jpg": 77,
	"./jalg.jpg": 78,
	"./juust.jpg": 79,
	"./kaed.jpg": 80,
	"./kamm.jpg": 81,
	"./kann.jpg": 82,
	"./karp.jpg": 83,
	"./keel.jpg": 84,
	"./kell.jpg": 85,
	"./king.jpg": 86,
	"./kirp.jpg": 87,
	"./koer.jpg": 88,
	"./konn.jpg": 89,
	"./korv.jpg": 90,
	"./kurg.jpg": 91,
	"./laud.jpg": 92,
	"./lehm.jpg": 93,
	"./leib.jpg": 94,
	"./lind.jpg": 95,
	"./luup.jpg": 96,
	"./maed.jpg": 97,
	"./mand.jpg": 98,
	"./muts.jpg": 99,
	"./niit.jpg": 100,
	"./noel.jpg": 101,
	"./noid.jpg": 102,
	"./noop.jpg": 103,
	"./noor1.jpg": 104,
	"./ois.jpg": 105,
	"./ong.jpg": 106,
	"./paat.jpg": 107,
	"./pall.jpg": 108,
	"./pilv.jpg": 109,
	"./pirn.jpg": 110,
	"./pliit.jpg": 111,
	"./poiss.jpg": 112,
	"./polv.jpg": 113,
	"./rong.jpg": 114,
	"./roos.jpg": 115,
	"./ruut.jpg": 116,
	"./sarg.jpg": 117,
	"./silm.jpg": 118,
	"./solm.jpg": 119,
	"./tilk.jpg": 120,
	"./vaht.jpg": 121,
	"./vaip.jpg": 122,
	"./vann.jpg": 123,
	"./voi.jpg": 124
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76;